import MatchType from "./MatchType";
import IndexData from "./IndexData";
import Index from "./Index";

export default class IndexUtil {

    static handleIndex(data) {
        if (!data) return [];
        let companys = [];
        for (let i = 0; i < data.length; i++) {
            if (!companys[data[i].company_id]) {
                companys[data[i].company_id] = new IndexData();
                companys[data[i].company_id].company_id = data[i].company_id;
            }
            if (data[i].is_initial == 1) {
                companys[data[i].company_id].initIdex = new Index(data[i]);
            } else if (data[i].is_initial == 2) {
                companys[data[i].company_id].realTime = new Index(data[i]);
            }
        }
        return companys;
    }


    static jqsjp(a, b, data, func) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let init = item.initIdex;
                let real = item.realTime;
                if (init && real) {
                    if (func(init.getasia1(a, b), real.getasia1(a, b))) {
                        total++;
                    }
                }
            }
        }
        return total;
    }

    static jqgs(data) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let real = item.realTime;
                if (real) {
                    let asia1 = real.getasia1(2, 0);
                    if (asia1 != '') {
                        if (asia1 >= 1) {
                            total++;
                        }
                    }

                }
            }
        }
        return total;
    }

    static jqds(data) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let real = item.realTime;
                if (real) {
                    let asia1 = real.getasia1(2, 0);
                    if (asia1 != '') {
                        if (asia1 <= 0.85) {
                            total++;
                        }
                    }
                }
            }

        }
        return total;
    }

    static rqsjp(a, b, data, func) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let init = item.initIdex;
                let real = item.realTime;
                if (init && real) {
                    if (func && func(init.getbs1(a, b), real.getbs1(a, b))) {
                        total++;
                    }
                }
            }
        }
        return total;
    }


    static rqgs(data) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let real = item.realTime;
                if (real) {
                    let bs1 = real.getbs1(2, 0)
                    if (bs1 != '') {
                        if (bs1 >= 1) {
                            total++;
                        }
                    }
                }
            }
        }
        return total;
    }

    static rqds(data) {
        if (!data) return 0;
        let total = 0;
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let item = data[keys[i]];
            if (item) {
                let real = item.realTime;
                if (real) {
                    let bs1 = real.getbs1(2, 0);
                    if (bs1 != '') {
                        if (bs1 <= 0.85) {
                            total++;
                        }
                    }
                }
            }
        }
        return total;
    }

}
